import axios from 'axios';

import { appConfig } from 'src/app';

class AgreementsServiceClientImpl {
    private getLicencePdfUrl: string;

    private getBookingTermsPdfUrl: string;

    constructor() {
        this.getLicencePdfUrl = appConfig.getLicencePdfUrl!;
        this.getBookingTermsPdfUrl = appConfig.getBookingTermsPdfUrl!;
    }

    public async getAgreementPdf(buildingSlug: string): Promise<string> {
        try {
            const response = await axios.get(this.getLicencePdfUrl, {
                params: {
                    building: buildingSlug,
                },
            });
            return response.data;
        } catch (error) {
            throw new Error('Failed to load licence agreement PDF', error);
        }
    }

    public async getBookingTermsPdf(brand: string): Promise<string> {
        try {
            const response = await axios.get(this.getBookingTermsPdfUrl, {
                params: { brand },
            });
            return response.data;
        } catch (error) {
            throw new Error('Failed to load booking terms PDF', error);
        }
    }
}

export default AgreementsServiceClientImpl;
